const FilesTitle = ({ itemsSize, isLoading }) => {
  if (isLoading) {
    return s__('MediaCenter|Files');
  }

  return ns__(
    'MediaCenter|File (%{count})',
    'MediaCenter|Files (%{count})',
    itemsSize,
  ).i__({
    count: itemsSize,
  });
};

const FoldersTitle = ({ itemsSize, isLoading }) => {
  if (isLoading) {
    return s__('MediaCenter|Folders');
  }

  return ns__(
    'MediaCenter|Folder (%{count})',
    'MediaCenter|Folders (%{count})',
    itemsSize,
  ).i__({
    count: itemsSize,
  });
};

export { FilesTitle, FoldersTitle };
